import { autoinject, computedFrom, PLATFORM, useView } from "aurelia-framework";
import { SignalClientService, SignalFunctions } from '@rightship-tech/common-ui/services/basic/signal-client.service';
import { DialogClientService } from '@rightship-tech/common-ui/services/basic/dialog-client.service';
import { UserClientService } from "@rightship-tech/common-ui/services/basic/user-client.service";
import { DueDiligenceDialogConstants } from "../../../../../constants/dialog.constants";
import { NoteModel } from "../../../../../models/notes.models";
import { NotesApi } from "../../../../../apis/notes.api";
import { UserClaimsService } from "@rightship-tech/common-ui/services/basic/user-claims.service";
import { DueDiligenceClaims } from "../../../../../constants/claims.constants";
import { Reflection } from "@rightship-tech/common-ui/helpers/reflection";

@autoinject
@useView(PLATFORM.moduleName("@rightship-tech/due-diligence-app/views/pages/due-diligence/tabs/notes/due-diligence-notes.html"))
export class DueDiligenceNotes {

    public note: string;
    public notes: NoteModel[] = [];
    public isLoadingNotes: boolean = true;
    public currentUserId: number;
    public currentUserBu: number;
    public isPrivate: boolean = true;
    public entityTypeId: number;
    public entityId: number;
    public item: any;
    public canAddAndDeleteNotes: boolean;

    @computedFrom(Reflection.getPropertyPath<DueDiligenceNotes>(x => x.note))
    public get canSubmit() {
        if(this.note)
        { 
            const div = document.createElement('div');
            div.innerHTML = this.note;
            const textContent = div.textContent || div.innerText || "";
            div.remove();
            return textContent?.trim()?.length > 0;
        }
    }

    constructor(private signalClientService: SignalClientService, private userClientService: UserClientService,
        private notesApi: NotesApi, private dialogClientService: DialogClientService, private userClaimsService: UserClaimsService) {
    }

    activate(model: { entityTypeId: number, entityId: number, item: any }) {
        if (model) {
            this.item = model.item;
            this.entityTypeId = model.entityTypeId;
            this.entityId = model.entityId;
        }
    }

    async attached() {

        //Claims
        this.canAddAndDeleteNotes = this.userClaimsService.hasPermission(DueDiligenceClaims.CanAddAndDeleteNotesInDueDiligence);
        this.currentUserId = this.userClientService.currentUser?.user?.userId;
        this.currentUserBu = this.userClientService.currentUser?.businessUnit?.businessUnitId ?? -1;

        //Get notes
        await this.loadNotes();

        //SignalR subscribe
        this.signalClientService.subscribe(SignalFunctions.refreshComments, this.refreshNotes);
    }

    private async loadNotes() {
        try
        {
            this.isLoadingNotes = false;
            this.notes = await this.notesApi.getNotes(this.entityId, this.entityTypeId);
            this.isLoadingNotes = false;
        }
        catch(e)
        {
            this.isLoadingNotes = false;
            console.error(e);
        }
    }

    detached() {

        //SignalR unsubscribe
        this.signalClientService.unsubscribe(SignalFunctions.refreshComments, this.refreshNotes);
    }

    //Submit
    public async submit() {
        if (this.note) {
            let div = document.createElement('div');
            div.innerHTML = this.note;
            if (div.children.length) {
                await this.notesApi.addNote(this.entityId, this.entityTypeId, this.note, this.isPrivate);
                this.note = "";
            }
            div.remove();
            div = null;
        }
    }

    //Delete note
    public deleteNote(note: NoteModel) {
        this.dialogClientService.show(DueDiligenceDialogConstants.ConfirmDeleteNoteDialog, { noteId: note.entityCommentId, onDelete: () => this.loadNotes() }, true);
    }

    //Refresh notes with SignalR
    public refreshNotes = async (payload: any) => {
        if (this.entityId == payload.entityId && this.entityTypeId == payload.entityTypeId) {
            
            if (!this.notes) {
                this.notes = [];
            }

            if (!payload.isPrivate || this.currentUserBu == payload.businessUnitId || this.currentUserId == payload.userId) {

                await this.loadNotes();
            }
        }
    }
}